import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";
import { MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS } from "../Cardiology/sections";

export const DischargeLetterENTFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
>["sections"] = [
  {
    fields: {
      additional_findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .futherFindingsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_findings"
            placeholder=" "
          />
        ),
        position: 7,
      },
      admission_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .medicationUponAdmission
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="admission_medications"
            placeholder=" "
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .medicalHistoryLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
            placeholder=" "
          />
        ),
        position: 4,
      },
      clinical_course: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.historyLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="clinical_course"
            placeholder=" "
          />
        ),
        position: 9,
      },
      diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.diagnosisLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
            placeholder=" "
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .dischargeMedicationLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
            placeholder=" "
          />
        ),
        position: 10,
      },
      findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.findingsLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="findings"
            placeholder=" "
          />
        ),
        position: 6,
      },
      laboratory_parameters: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .laboratoryParameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="laboratory_parameters"
            placeholder=" "
          />
        ),
        position: 8,
      },
      recommendations: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.recommendation
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="recommendations"
            placeholder=" "
          />
        ),
        position: 11,
      },
      secondary_diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt
                .secondaryDiagnoses
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="secondary_diagnoses"
            placeholder=" "
          />
        ),
        position: 2,
      },
      therapy: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formEnt.therapyLabel
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy"
            placeholder=" "
          />
        ),
        position: 3,
      },
    },
    position: 1,
  },
];
